<template>
  <div>
    <div v-if="candidates.length > 0">
      <div style="text-align: left; margin: 0.4rem; padding: 0.5rem; font-size: 1.8rem; background-color: #3d4249; color: white">Candidates</div>
      <div v-for="(value, index) in candidates" :key="index">
        <table style="margin-top: 0 !important;">
          <tr>
            <th style="background-color: var(--synop-select-color)">User ID: {{ value.user_id }}</th>
          </tr>
          <tr>
            <th>Time</th>
            <th>URL</th>
            <th>Method</th>
            <th>Error Status</th>
            <th>Status Text</th>
            <th>Message</th>
          </tr>
          <tr v-for="(item, index) in value.value" :key="index">
            <td>{{new Date(item.time)}}</td>
            <td>{{item.log.url}}</td>
            <td>{{item.log.method}}</td>
            <td>{{item.log.status}}</td>
            <td>{{item.log.statusText}}</td>
            <td>{{item.log.data}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="employers.length > 0">
      <div style="text-align: left; margin: 0.4rem; padding: 0.5rem; font-size: 1.8rem; background-color: #3d4249; color: white">Employers</div>
      <div v-for="(value, index) in employers" :key="index">
        <div>{{ value.user_id }}</div>
        <table style="margin-top: 0 !important;">
          <tr>
            <th>User ID: {{ value.user_id }}</th>
          </tr>
          <tr>
            <th>Time</th>
            <th>URL</th>
            <th>Method</th>
            <th>Error Status</th>
            <th>Status Text</th>
            <th>Message</th>
          </tr>
          <tr v-for="(item, index) in value.value" :key="index">
            <td>{{new Date(item.time)}}</td>
            <td>{{item.log.url}}</td>
            <td>{{item.log.method}}</td>
            <td>{{item.log.status}}</td>
            <td>{{item.log.statusText}}</td>
            <td>{{item.log.data}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="unknown_public.length > 0">
      <div style="text-align: left; margin: 0.4rem; padding: 0.5rem; font-size: 1.8rem; background-color: #3d4249; color: white">Public</div>
      <table style="margin-top: 0 !important;">
        <tr>
          <th>Time</th>
          <th>URL</th>
          <th>Method</th>
          <th>Error Status</th>
          <th>Status Text</th>
          <th>Message</th>
        </tr>
        <tr v-for="(value, index) in unknown_public" :key="index">
          <td>{{new Date(value.time)}}</td>
          <td>{{value.log.url}}</td>
          <td>{{value.log.method}}</td>
          <td>{{value.log.status}}</td>
          <td>{{value.log.statusText}}</td>
          <td>{{value.log.data}}</td>
        </tr>
      </table>
    </div>
    <div v-if="login.length > 0">
      <div style="text-align: left; margin: 0.4rem; padding: 0.5rem; font-size: 1.8rem; background-color: #3d4249; color: white">Log In</div>
      <table style="margin-top: 0 !important;">
        <tr>
          <th>Time</th>
          <th>URL</th>
          <th>Method</th>
          <th>Error Status</th>
          <th>Status Text</th>
          <th>Message</th>
        </tr>
        <tr v-for="(value, index) in login" :key="index">
          <td>{{new Date(value.time)}}</td>
          <td>{{value.log.url}}</td>
          <td>{{value.log.method}}</td>
          <td>{{value.log.status}}</td>
          <td>{{value.log.statusText}}</td>
          <td>{{value.log.data}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
    import firebase from "firebase/app"
    import "firebase/database"
    export default {
        data: () => ({
            candidates: [],
            employers: [],
            unknown_public: [],
            login: [],
        }),
        mounted() {
            const self = this;
            firebase.database().ref("web-application/candidates/").on("value", val => {
                    val.forEach(child => {
                        let item = {
                            value: child.val(),
                            user_id: child.key
                        };
                        self.candidates.push(item)
                    });
            });
            firebase.database().ref("web-application/employers/").on("value", val => {
                val.forEach(child => {
                    let item = {
                        value: child.val(),
                        user_id: child.key
                    };
                    self.employers.push(item)
                });
            });
            firebase.database().ref("web-application/public/").on("value", val => {
                val.forEach(child => {
                    let item = child.val();
                    self.unknown_public.push(item)
                });
            });
            firebase.database().ref("web-application/login/").on("value", val => {
                val.forEach(child => {
                    let item = child.val();
                    self.login.push(item)
                });
            });

        }
    };
</script>

<style scoped>
  table {
    margin: 5rem 0;
    font-family: arial, sans-serif;
    border-collapse: separate;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
    border-radius: 0.4rem;
  }

  tr:nth-child(even) {
    background-color: #ebebeb;
  }
</style>
